const uploadAccept = "image/*,.heic,.psd,.heif";
export default uploadAccept;

export const MaxUploadAmount = 50;
